import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        $(this.element).find(".dynamic-select").select2({ theme: "bootstrap4", minimumResultsForSearch: Infinity });
    }
}
